<template>
    <div class="content-body">
        <voyage :user="user" :subscription="subscription" v-if="subscription.product_id && subscription.product_id =='3'"/>
        <auto :user="user" :guarantees="guarantees" :subscription="subscription" v-if="subscription.product_id && subscription.product_id =='1'"/>
        <habitation :user="user" :subscription="subscription" v-if="subscription.product_id && subscription.product_id =='2'"/>
    </div>
</template>

<script>
import voyage from './medetails/voyage.vue'
import auto from './medetails/auto.vue'
import habitation from './medetails/habitation.vue'
export default {
    props: ['content','identity', 'ga'],
    components:{ voyage, auto, habitation },
    data: () => ({
        subscription: {},
        user: {},
        guarantees: []
    }),
    created(){
        this.subscription = JSON.parse(this.content);
        this.user = JSON.parse(this.identity);
        this.guarantees = JSON.parse(this.ga)
    }
}
</script>
